<template>
  <div class="device-info-content">
    <div class="content-header">
      <div class="icon" :class="[ deviceCollapsed? 'icon-arrow_down' : 'icon-arrow_up' ]" @click="onDeviceClick"/>
      <div class="title">{{$t('deviceinfo.dashboard')}}</div>
    </div>
    <div class="content-body" v-if="!deviceCollapsed">
      <div class="device-left">
        <div class="formRow">
          <div class="title">{{$t('deviceinfo.info')}}</div>
          <div class="forminput">
            <q-select class="status-select" :options-array="menuOptions" :value="selectType" :isWhite="false" @change="onMenuChange"></q-select>
          </div>
        </div>
        <div class="formRow">
          <machine ref="machine" v-if="reRender"></machine>
        </div>
        <div class="formRow legend">
          <span v-if="isPortMirroring" class="mirror_source legent-item">{{$t('mirroring.sourceNoColon')}}</span>
          <span v-if="isPortMirroring" class="mirror_des legent-item">{{$t('mirroring.destinationNoColon')}}</span>
          <div class="link legent-item">{{$t('linkUp')}}</div>
          <div class="nolink">{{$t('linkDown')}}</div>
          <div class="icon-tick ft-14 legent-item">{{$t('port.enabled')}}</div>
          <div class="icon-btn_close ft-14 legent-item">{{$t('port.disabled')}}</div>
        </div>
      </div>
      <div class="line"></div>
      <div class="device-right">
        <div class="header">{{rightTitle}}</div>
        <scrollbar ref="scrollbar" class="scrollbar-body">
          <div class="detail" v-if="selectType === 'port'">
            <ul>
              <li v-for="item in linkOptions" :key="item" @mouseenter="mouseAction('enter',item)" @mouseleave="mouseAction('leave',item)" @click="mouseAction('click', item)" :class="{onclick: getClickStatus(item)}">
                <div class="title">{{$t(item)}}:</div>
                <span class="value">{{(linkStatus[item]) ? linkStatus[item].length : '-'}} {{$t('smallPort')}}</span>
              </li>
            </ul>
          </div>
          <div class="detail" v-if="selectType === 'lacp'">
            <ul v-for="idx in 2" :key="idx">
              <li v-for="(item, index) in lacpList" :key="item.key" v-if="index < idx*5 && index >= (idx-1)*5" @mouseenter="mouseAction('enter',item)" @mouseleave="mouseAction('leave',item)" @click="mouseAction('click', item)" :class="{onclick: getClickStatus(item)}">
                <div class="title">{{$t('lag.groupName') + ' ' + item.key}}:</div>
                <span class="value">{{item.val['PortMembers'].length}} {{$t('smallPort')}}</span>
              </li>
            </ul>
          </div>
          <div class="detail" v-if="selectType === 'vlan'">
            <ul v-for="idx in 2" :key="idx">
              <li v-for="(item, index) in vlanList" :key="item.key" v-if="index < idx*(vlanList.length/2) && index >= (idx-1)*(vlanList.length/2)" @mouseenter="mouseAction('enter',item)" @mouseleave="mouseAction('leave',item)" @click="mouseAction('click', item)" :class="{onclick: getClickStatus(item)}">
                <div class="title">{{$t('menu.vlan')}} {{item.key}}:</div>
                <span class="value">{{item.val.length}} {{$t('smallPort')}}</span>
              </li>
            </ul>
          </div>
          <div class="detail rate" v-if="selectType === 'oneG' || selectType === '2G5' || selectType === 'tenG' || selectType === 'twentyG5'">
            <div class="col-body">
              <div class="port">
                {{$t('deviceinfo.port')}}
                <div class="port-cell all" :class="{ selected: selectPort === 0 }" @click="onChangePort(0)">{{$t('all')}}</div>
                <div v-for="num in portNumber" v-if="getPortCell(num)" :key="num" class="rate-data port-cell" :class="{ selected: selectPort === num}" @click="onChangePort(num)">{{num}}</div>
              </div>
              <ve-line ref="rate" :data="rateData" :settings="rateConfig.setting" :y-axis="rateConfig.yAxis" :extend="rateConfig.extend" :grid="rateConfig.grid" :colors="rateConfig.color" height="148px"></ve-line>
            </div>
          </div>
        </scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import qSelect from './module/Select.vue'
import VeLine from 'v-charts/lib/line.common'
import ledgendLine from '../assets/svg/line.svg'
import machine from './module/Machine'
import utility from '../util/utility'
import config from '../config'
export default {
  name: 'device-info',
  components: {
    qSelect,
    VeLine,
    ledgendLine,
    machine
  },
  created: function () {
    if (this.systemHostInfo.Product.includes('M408')) {
      this.menuOptions = [
        { value: 'port', label: 'deviceinfo.portStatus' },
        { value: 'vlan', label: 'deviceinfo.vlanStatus' },
        { value: 'lacp', label: 'deviceinfo.LAGStatus' },
        { value: 'oneG', label: 'deviceinfo.oneGStatus' },
        { value: 'tenG', label: 'deviceinfo.tesGStatus' }
      ]
    } else if (this.systemHostInfo.Product.includes('M2108') || this.systemHostInfo.Product.includes('M2106')) {
      this.menuOptions = [
        { value: 'port', label: 'deviceinfo.portStatus' },
        { value: 'vlan', label: 'deviceinfo.vlanStatus' },
        { value: 'lacp', label: 'deviceinfo.LAGStatus' },
        { value: '2G5', label: 'deviceinfo.twoG5Status' },
        { value: 'tenG', label: 'deviceinfo.tesGStatus' }
      ]
    } else if (this.systemHostInfo.Product.includes('M5216-1T')) {
      this.menuOptions = [
        { value: 'port', label: 'deviceinfo.portStatus' },
        { value: 'vlan', label: 'deviceinfo.vlanStatus' },
        { value: 'lacp', label: 'deviceinfo.LAGStatus' },
        { value: 'tenG', label: 'deviceinfo.tesGStatus' },
        { value: 'twentyG5', label: 'deviceinfo.twentyG5Status' }
      ]
    } else {
      this.menuOptions = [
        { value: 'port', label: 'deviceinfo.portStatus' },
        { value: 'vlan', label: 'deviceinfo.vlanStatus' },
        { value: 'lacp', label: 'deviceinfo.LAGStatus' },
        { value: 'tenG', label: 'deviceinfo.tesGStatus' }
      ]
    }
  },
  data () {
    return {
      menuOptions: [
        { value: 'port', label: 'deviceinfo.portStatus' },
        { value: 'vlan', label: 'deviceinfo.vlanStatus' },
        { value: 'lacp', label: 'deviceinfo.lacpStatus' },
        { value: 'oneG', label: 'deviceinfo.oneGStatus' },
        { value: 'tenG', label: 'deviceinfo.tesGStatus' }
      ],
      selectType: 'port',
      portStatusInterval: null,
      selectInterval: null,
      startTime: null,
      selectPort: 0,
      typeList: [],
      portList: [],
      lacpList: [],
      vlanList: [],
      portStatusIntervalList: [],
      linkStatus: {},
      linkOptions: ['linkUp', 'linkDown', 'port.enabled', 'port.disabled'], // , 'tenGlink'
      rateIndex: 0,
      rateConfig: {
        color: ['#F5A623', '#7ED321'],
        grid: {
          show: true,
          borderColor: 'none',
          top: 40,
          right: 60,
          bottom: 10,
          containLabel: true,
          height: '88px'
        },
        setting: {
          labelMap: {
            In: 'Traffic In',
            Out: 'Traffic Out'
          }
        },
        extend: {
          series: {
            symbol: 'none'
          },
          xAxis: {
            name: this.$t('menu.systime'),
            nameLocation: 'end',
            nameGap: 10,
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                type: 'dotted'
              }
            },
            axisLabel: {
              show: true,
              padding: [0, 0, 0, 20],
              interval: function (index, value) {
                if (index === 0 || index === 59) {
                  return true
                } else {
                  return false
                }
              },
              formatter: this.rateYlableFormatter
            },
            nameTextStyle: {
              color: '#8C99FF',
              fontSize: 13,
              lineHeight: 22
            }
          },
          legend: {
            show: true,
            orient: 'horizontal',
            selectedMode: false,
            textStyle: {
              color: '#000000'
            },
            itemWidth: 10,
            itemHeight: 3,
            right: 0,
            bottom: -5,
            formatter: this.legendFormatter,
            data: [
              {
                name: 'TrafficIn',
                icon: 'this.ledgendLine'
              }, {
                name: 'TrafficOut',
                icon: 'this.ledgendLine'
              }
            ]
          },
          tooltip: {
            formatter: this.rateTooltipFormatter
          }
        },
        yAxis: {
          name: this.$t('mbps'),
          axisLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
              color: '#8EA0F9',
              opacity: 0.5
            }
          },
          nameTextStyle: {
            color: '#8C99FF',
            fontSize: 13,
            lineHeight: 22
          }
        }
      },
      rateData: {
        columns: ['Time', 'TrafficIn', 'TrafficOut'],
        rows: []
      },
      ratePorts: [],
      clickStatus: false,
      clickItem: null,
      portSpeed: [],
      isPortMirroring: false,
      reRender: true,
      preRate: { first: [], second: [] }
    }
  },
  beforeDestroy () {
    this.$store.commit('updateGetDeviceData', false)
    clearInterval(this.portStatusInterval)
    clearInterval(this.selectInterval)
    this.portStatusInterval = null
    this.selectInterval = null
    this.onClose()
  },
  mounted () {
    this.$store.commit('updateGetDeviceData', true)
    if (this.getDeviceData) {
      // this.getData()
    } else {
      this.onClose()
    }
    // if (this.systemHostInfo && !this.systemHostInfo.Product.includes('M408') && !this.systemHostInfo.Product.includes('M2108')) {
    //   this.linkOptions = ['linkUp', 'linkDown', 'port.enabled', 'port.disabled', 'tenGlink']
    // }
  },
  watch: {
    currentUser: {
      handler (value) {
        if (!value) {
          this.$store.commit('updateGetDeviceData', false)
          clearInterval(this.portStatusInterval)
          clearInterval(this.selectInterval)
          this.portStatusInterval = null
          this.selectInterval = null
          this.onClose()
        }
      },
      immediate: true,
      deep: true
    },
    deviceCollapsed: {
      handler (value) {
        if (!value) {
          this.$store.commit('updateGetDeviceData', true)
        } else {
          this.$store.commit('updateGetDeviceData', false)
          this.onClose()
        }
      }
    },
    getDeviceData: {
      handler (value) {
        if (value) {
          this.getData()
        } else {
          this.onClose()
        }
      }
    },
    showFullLoading: function (value) {
      if (value) {
        clearInterval(this.portStatusInterval)
        clearInterval(this.selectInterval)
        this.portStatusInterval = null
        this.selectInterval = null
      }
    },
    reloadDeviceInfo: function (value) {
      if (value && this.portStatusInterval === null) {
        this.getData()
        this.$store.commit('updateReloadDeviceStatus', null)
      }
    },
    selectMenu: function (value) {
      if (value.alias === 'dashboard') {
        clearInterval(this.portStatusInterval)
        clearInterval(this.selectInterval)
        this.portStatusInterval = null
        this.selectInterval = null
        this.onClose()
      }
    },
    $route: {
      handler (value) {
        if (value.name === 'portmirroring') {
          this.isPortMirroring = true
        } else {
          this.isPortMirroring = false
        }
      }
    },
    isPortMirroring () {
      this.reRender = false
      setTimeout(() => {
        this.reRender = true
      }, 0)
    },
    lang: {
      handler (value) {
        setTimeout(() => {
          this.$forceUpdate()
        }, 200)
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions([
      'getPortStatus', 'getLagStatus', 'getVlan', 'getPortStatistics', 'getPortConfigure'
    ]),
    getData: async function () {
      let me = this
      if (this.portStatusInterval === null && !this.deviceCollapsed) {
        await this.axios.all([this.getPortStatus(), this.getPortConfigure()])
          .then(this.axios.spread(function (status, config) {
            let tempArray = null
            if (status.data.error_code === 200 && status.data.result) {
              if (config.data.error_code === 200 && config.data.result) {
                tempArray = status.data.result
                config.data.result.forEach((item, index) => {
                  let val = tempArray[index].val
                  val['Shutdown'] = item.val['Shutdown']
                  val['Combo'] = item.val['Combo']
                  val['MediaType'] = item.val['MediaType']
                  tempArray[index].val = val
                })
                status.data.result.forEach((item, index) => {
                  me.portSpeed[index] = item.val.Speed
                })
              }
              me.portList = tempArray
              me.setDeviceColor()
              me.getLinkStatusDetail()
              me.getDataByInterval()
            }
          }))
      }
    },
    getDataByInterval: async function () {
      let me = this
      if (this.portStatusIntervalList.length > 0) {
        this.portStatusIntervalList.forEach(elements => {
          clearInterval(elements)
        })
        this.portStatusIntervalList = []
      }
      if (!this.deviceCollapsed || this.getDeviceData) {
        this.portStatusInterval = setInterval(() => {
          if (me.showFullLoading || me.selectMenu.path === 'dashboard') {
            clearInterval(me.portStatusInterval)
            clearInterval(me.selectInterval)
            me.portStatusInterval = null
            me.selectInterval = null
          } else {
            if (me.$router.currentRoute.name !== 'portstatus') {
              me.axios.all([me.getPortStatus(), me.getPortConfigure()])
                .then(me.axios.spread(function (status, config) {
                  if (!me.getDeviceData) {
                    me.onClose()
                  } else {
                    let tempArray = null
                    if (status.data.error_code === 200 && status.data.result) {
                      if (config.data.error_code === 200 && config.data.result) {
                        tempArray = status.data.result
                        config.data.result.forEach((item, index) => {
                          let val = tempArray[index].val
                          val['Shutdown'] = item.val['Shutdown']
                          val['Combo'] = item.val['Combo']
                          val['MediaType'] = item.val['MediaType']
                          tempArray[index].val = val
                        })
                      }
                      me.portList = tempArray
                      me.setDeviceColor()
                      me.getLinkStatusDetail()
                      me.$store.commit('setPortStatus', me.portList)
                    }
                  }
                }))
            } else {
              if (!me.getDeviceData) {
                me.onClose()
              } else {
                let tempArray = null
                tempArray = me.portStatus
                me.portStatus.forEach((item, index) => {
                  let val = tempArray[index].val
                  val['Shutdown'] = item.val['Shutdown']
                  val['Combo'] = item.val['Combo']
                  val['MediaType'] = item.val['MediaType']
                  tempArray[index].val = val
                })
                me.portList = tempArray
                me.setDeviceColor()
                me.getLinkStatusDetail()
              }
            }
          }
        }, this.intervalTime)
      } else {
        this.onClose()
      }
      this.portStatusIntervalList.push(this.portStatusInterval)
      this.changeData()
    },
    getVlanData: function () {
      let self = this
      this.getVlan().then((res) => {
        if (!this.getDeviceData) {
          clearInterval(this.portStatusInterval)
          clearInterval(this.selectInterval)
          this.onClose()
        } else {
          if (res.data && res.data.error_code === 200) {
            let detail = res.data.result
            let tempArray = []
            detail.forEach(element => {
              if (element.val) {
                let tempObj = {key: element.key, val: []}
                element.val.forEach(item => {
                  let mapItem = self.lagGroupMap.get(Number(item.Port))
                  if (mapItem) {
                    mapItem.forEach(lagitem => {
                      tempObj.val.push(lagitem)
                    })
                  }
                  if (parseInt(item.Port) < self.portNumber + 1) {
                    tempObj.val.push(item.Port)
                  }
                })
                tempArray.push(tempObj)
              }
            })
            this.vlanList = tempArray
          }
        }
      })
    },
    getLacpData: function () {
      this.getLagStatus().then((res) => {
        if (!this.getDeviceData) {
          clearInterval(this.portStatusInterval)
          clearInterval(this.selectInterval)
          this.onClose()
        } else {
          if (res.data.error_code === 200 && res.data.result) {
            let temp = []
            res.data.result.forEach(element => {
              if (Number(element.key) <= this.lagGroupMap.size) {
                temp.push(element)
              }
            })
            this.lacpList = temp
          }
        }
      })
    },
    getTrafficData: function () {
      let me = this
      this.getPortStatistics().then((res) => {
        me.rateConfig.extend.xAxis.name = me.$t('menu.systime')
        if (!this.getDeviceData) {
          clearInterval(this.portStatusInterval)
          clearInterval(this.selectInterval)
          this.onClose()
        } else {
          if (res.data.error_code === 200 && res.data.result) {
            let portStatistic = {}
            if (this.selectPort !== 0) {
              let data = res.data.result[this.selectPort - 1]
              portStatistic = {
                'TxOctets': data.val.TxOctets,
                'RxOctets': data.val.RxOctets,
                'TimeStamp': Math.floor((new Date().getTime() - this.startTime) / 1000)
              }
            } else {
              let oneTemp, tenTemp, twenty5Temp, tempData
              let txTotal = 0
              let rxTotal = 0
              if (this.systemHostInfo.Product.includes('M408') || this.systemHostInfo.Product.includes('M2108')) {
                oneTemp = res.data.result
                tenTemp = oneTemp.splice(8)
              } else if (this.systemHostInfo.Product.includes('M5216-1T')) {
                twenty5Temp = res.data.result
                tenTemp = twenty5Temp.splice(16)
              } else if (this.systemHostInfo.Product.includes('M2106')) {
                oneTemp = res.data.result
                tenTemp = oneTemp.splice(6)
              } else {
                oneTemp = []
                tenTemp = res.data.result
              }
              if (this.selectType === 'oneG' || this.selectType === '2G5') {
                tempData = oneTemp
              } else if (this.selectType === 'tenG') {
                tempData = tenTemp
              } else if (this.selectType === 'twentyG5') {
                tempData = twenty5Temp
              }
              tempData.forEach((element, index) => {
                let number = parseInt(element.key)
                let idx = (number < 9) ? index : (this.systemHostInfo.Model.includes('M120') || this.systemHostInfo.Model.includes('M804')) ? index : index + 8
                if (this.systemHostInfo.Product.includes('M5216-1T')) idx = (number < 17) ? index : index + 16
                if (this.systemHostInfo.Model.includes('M2106')) {
                  idx = (number > 6) ? (index + 6) : index
                }
                let maxSpeed = (me.portSpeed[number - 1] / 1000 * 1024) * 3 / 8 * 1024 * 1024
                if (number <= me.portNumber) {
                  maxSpeed = (me.portSpeed[number - 1] / 1000 * 1024) * 3 / 8 * 1024 * 1024
                  me.preRate.first[number - 1] = me.preRate.second[number - 1]
                  me.preRate.second[number - 1] = {
                    'portNum': number,
                    'TxOctets': element.val.TxOctets,
                    'RxOctets': element.val.RxOctets
                  }
                  if (me.ratePorts[1]) {
                    let nowT, nowR
                    nowT = Math.abs(me.preRate.second[number - 1].TxOctets - me.preRate.first[number - 1].TxOctets)
                    nowR = Math.abs(me.preRate.second[number - 1].RxOctets - me.preRate.first[number - 1].RxOctets)
                    if (nowT > maxSpeed) me.preRate.second[number - 1].TxOctets = (me.preRate.first[number - 1].TxOctets + maxSpeed)
                    if (nowR > maxSpeed) me.preRate.second[number - 1].RxOctets = (me.preRate.first[number - 1].RxOctets + maxSpeed)
                    txTotal += me.preRate.second[number - 1].TxOctets
                    rxTotal += me.preRate.second[number - 1].RxOctets
                  } else if (me.preRate.first[number - 1]) {
                    txTotal += element.val.TxOctets
                    rxTotal += element.val.RxOctets
                  }
                  if (!this.portList[idx].val.Link || (element.val.TxOctets === 0 && element.val.RxOctets === 0)) {
                    this.getDisable(number, 'disable')
                  } else {
                    this.getDisable(number, 'enable')
                  }
                }
              })
              portStatistic = {
                'TxOctets': txTotal,
                'RxOctets': rxTotal,
                'TimeStamp': Math.floor((new Date().getTime() - this.startTime) / 1000)
              }
            }
            let detail = null
            if (me.ratePorts.length === 2) {
              if (portStatistic.TxOctets > me.ratePorts[1].TxOctets && portStatistic.RxOctets > me.ratePorts[1].RxOctets) {
                me.ratePorts[0] = me.ratePorts[1]
                me.ratePorts[1] = portStatistic
                detail = {
                  'TrafficOut': utility.bytesToMGb(Math.abs(me.ratePorts[1].TxOctets - me.ratePorts[0].TxOctets) * 8 / (me.intervalTime / 1000), true)[0],
                  'TrafficIn': utility.bytesToMGb(Math.abs(me.ratePorts[1].RxOctets - me.ratePorts[0].RxOctets) * 8 / (me.intervalTime / 1000), true)[0],
                  'Time': (me.rateIndex++).toString()
                }
              } else {
                detail = {
                  'TrafficOut': utility.bytesToMGb(Math.abs(me.ratePorts[1].TxOctets - me.ratePorts[0].TxOctets) * 8 / (me.intervalTime / 1000), true)[0],
                  'TrafficIn': utility.bytesToMGb(Math.abs(me.ratePorts[1].RxOctets - me.ratePorts[0].RxOctets) * 8 / (me.intervalTime / 1000), true)[0],
                  'Time': (me.rateIndex++).toString()
                }
                me.ratePorts[0] = me.ratePorts[1]
                me.ratePorts[1] = portStatistic
              }
            } else {
              me.ratePorts.push(portStatistic)
            }
            if (me.selectPort !== 0 && detail) {
              detail.TrafficIn = (detail.TrafficIn > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficIn
              detail.TrafficOut = (detail.TrafficOut > me.portSpeed[me.selectPort - 1] / 1000 * 1024) ? parseInt(me.portSpeed[me.selectPort - 1] / 1000 * 1024) : detail.TrafficOut
            }
            if (me.ratePorts.length >= 2 && detail) {
              me.rateData.rows.push(detail)
              me.rateData.rows.shift()
            }
          }
        }
      })
    },
    getDisable: function (port, type) {
      let elements = this.$getElementsByClassName(this.$refs.scrollbar.$el, 'rate-data')
      let number = (this.systemHostInfo.Model.includes('M120') || this.systemHostInfo.Model.includes('M5216')) ? port : (port > 8) ? (port - 8) : port
      if (this.systemHostInfo.Model.includes('M2106')) {
        number = (port > 6) ? (port - 6) : port
      }
      if (this.systemHostInfo.Model.includes('M5216') && number === 17) number = 1
      if (number <= this.portNumber) {
        if (type === 'enable') {
          elements[number - 1].className = elements[number - 1].className.split('disable')[0]
        } else {
          let isDisabled = elements[number - 1].classList.contains('disabled')
          if (!isDisabled) {
            elements[number - 1].className = elements[number - 1].className + ' disabled'
          }
        }
      }
    },
    getPortCell: function (port) {
      if (this.systemHostInfo.Product.includes('M408') || this.systemHostInfo.Product.includes('M2108')) {
        if (this.selectType === 'oneG' || this.selectType === '2G5') {
          if (port < 9) {
            return true
          } else {
            return false
          }
        } else {
          if (port > 8) {
            return true
          } else {
            return false
          }
        }
      } else if (this.systemHostInfo.Product.includes('M5216-1T')) {
        if (this.selectType === 'twentyG5') {
          if (port < 17) {
            return true
          } else {
            return false
          }
        } else {
          if (port === 17) {
            return true
          }
        }
      } else if (this.systemHostInfo.Product.includes('M2106')) {
        if (this.selectType === 'oneG' || this.selectType === '2G5') {
          if (port < 7) {
            return true
          } else {
            return false
          }
        } else {
          if (port > 6) {
            return true
          } else {
            return false
          }
        }
      } else {
        return true
      }
    },
    changeData: function () {
      clearInterval(this.selectInterval)
      this.clickStatus = false
      this.setClickItem('clear')
      this.clickItem = null
      if (this.selectType === 'port') {
        if (this.portStatusInterval === null) {
          this.getData()
        }
      } else if (this.selectType === 'vlan') {
        this.getVlanData()
        this.selectInterval = setInterval(() => {
          this.getVlanData()
        }, this.intervalTime)
      } else if (this.selectType === 'lacp') {
        this.getLacpData()
        this.selectInterval = setInterval(() => {
          this.getLacpData()
        }, this.intervalTime)
      } else if (this.selectType === 'oneG' || this.selectType === '2G5' || this.selectType === 'tenG' || this.selectType === 'twentyG5') {
        this.setRateInitailData()
        this.startTime = new Date().getTime()
        this.getTrafficData()
        this.selectInterval = setInterval(() => {
          this.getTrafficData()
        }, this.intervalTime)
      }
    },
    setDeviceColor: function () {
      let me = this
      let tempList = me.portList
      tempList.forEach((item, index) => {
        if (Number(item.key) <= me.portNumber) {
          let number = Number(item.key)
          let imgItem = (me.onlySFPlist.indexOf(number) < 0) ? document.getElementById('ethernet_' + number) : null
          let backgroundImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'unconnected')[0] : null
          let connectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_enable')[0] : null
          let unconnectImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'symbol_disable')[0] : null
          let sfpItem = (item.val.Combo || me.onlySFPlist.indexOf(number) > -1 || !me.systemHostInfo.Product.includes('M408')) ? document.getElementById('sfp_' + number) : null
          let sfpBackground = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'unconnected')[0] : null
          let sfpConnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_enable')[0] : null
          let sfpUnconnect = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'symbol_disable')[0] : null
          let connect = (item.val.Shutdown) ? 'hidden' : 'visible'
          let unconnected = (item.val.Shutdown) ? 'visible' : 'hidden'
          let tooltipsElement = (imgItem) ? document.getElementById('tooltip_' + number) : null
          let sfptooltipsElement = (sfpItem) ? document.getElementById('tooltip_sfp_' + number) : null
          let speed = utility.bytesToSize(item.val.Speed, 1000).split(' ').join('')
          if (!imgItem && !sfpItem) {
            clearInterval(this.portStatusInterval)
            clearInterval(this.selectInterval)
          }
          if (imgItem) {
            connectImg.style.visibility = connect
            unconnectImg.style.visibility = unconnected
            tooltipsElement.lastElementChild.textContent = speed
            imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
            imgItem.onmouseout = function () { tooltipsElement.style.visibility = 'hidden' }
          }
          if (sfpItem) {
            sfpConnect.style.visibility = connect
            sfpUnconnect.style.visibility = unconnected
            sfptooltipsElement.lastElementChild.textContent = speed
            sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
            sfpItem.onmouseout = function () { sfptooltipsElement.style.visibility = 'hidden' }
          }
          if (!item.val.Link) {
            if (imgItem) backgroundImg.style.fill = '#DBDDDD'
            if (sfpItem) sfpBackground.style.fill = '#DBDDDD'
            if (imgItem) imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
            if (sfpItem) sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
          } else {
            if (item.val.Combo) {
              if (item.val.MediaType === 'fiber') {
                sfpBackground.style.fill = '#7ED321'
                backgroundImg.style.fill = '#DBDDDD'
                sfpItem.onmouseover = function () {
                  me.setTransform('sfp', number, speed)
                  sfptooltipsElement.style.visibility = 'visible'
                }
                imgItem.onmouseover = function () { tooltipsElement.style.visibility = 'hidden' }
              } else if (item.val.MediaType === 'copper') {
                sfpBackground.style.fill = '#DBDDDD'
                backgroundImg.style.fill = '#7ED321'
                sfpItem.onmouseover = function () { sfptooltipsElement.style.visibility = 'hidden' }
                imgItem.onmouseover = function () {
                  me.setTransform('imgItem', number, speed)
                  tooltipsElement.style.visibility = 'visible'
                }
              } else {
                sfpBackground.style.fill = '#DBDDDD'
                backgroundImg.style.fill = '#DBDDDD'
              }
            } else if (me.onlySFPlist.indexOf(number) > -1) {
              sfpBackground.style.fill = '#7ED321'
              sfpItem.onmouseover = function () {
                me.setTransform('sfp', number, speed)
                sfptooltipsElement.style.visibility = 'visible'
              }
            } else {
              backgroundImg.style.fill = '#7ED321'
              imgItem.onmouseover = function () {
                tooltipsElement.style.visibility = 'visible'
                me.setTransform('imgItem', number, speed)
              }
            }
          }
        }
      })
    },
    getLinkStatusDetail: function () {
      let me = this
      let tempObj = {
        'linkUp': [],
        'linkDown': [],
        'port.enabled': [],
        'port.disabled': [],
        'tenGlink': []
      }
      this.portList.forEach(element => {
        if (Number(element.key) <= me.portNumber) {
          element.val['Shutdown'] ? tempObj['port.disabled'].push(element.key) : tempObj['port.enabled'].push(element.key)
          element.val['Link'] ? tempObj['linkUp'].push(element.key) : tempObj['linkDown'].push(element.key)
          if (element.val['Combo'] && element.val['Link'] && element.val['Speed'] === '10000') {
            tempObj['tenGlink'].push(element.key)
          }
        }
      })
      this.linkStatus = tempObj
    },
    onMenuChange (value) {
      this.selectType = value
      this.selectPort = 0
      this.changeData()
    },
    setRateInitailData: function () {
      this.rateIndex = 0
      this.rateData.rows = []
      this.ratePorts = []
      for (var index = 0; index < 60; index++) {
        this.rateData.rows.push({
          'Time': (this.rateIndex++).toString(), 'TrafficIn': 0, 'TrafficOut': 0
        })
      }
    },
    onChangePort: function (portNum) {
      this.selectPort = portNum
      this.changeData()
      this.ratePorts = []
    },
    rateTooltipFormatter: function (params) {
      let Tin = params[0].marker + ' ' + this.$t('overview.trafficIn') + ': ' + params[0].data[1].toFixed(2)
      let Tout = params[1].marker + ' ' + this.$t('overview.trafficOut') + ': ' + params[1].data[1].toFixed(2)
      return Tin + '<br>' + Tout
    },
    rateYlableFormatter: function (value, index) {
      if (index === 0) {
        return ' ' + this.$t('minAgo')
      } else if (index === 59) {
        return this.$t('now')
      }
    },
    legendFormatter: function (name) {
      let result = ''
      if (name === 'TrafficIn') {
        result = this.$t('overview.trafficIn')
      } else {
        result = this.$t('overview.trafficOut')
      }
      return result
    },
    getTempList: function (item) {
      let list = null
      if (item) {
        switch (this.selectType) {
          case 'port':
            list = this.linkStatus[item]
            break
          case 'vlan':
            list = item.val
            break
          case 'lacp':
            list = item.val['PortMembers']
            break
          default:
            break
        }
      }
      return list
    },
    mouseAction: async function (type, item) {
      let me = this
      let portNumber, tempList, imgItem, circelImg, textImg, sfpItem, sfpCircleImg, sfpTextImg, sameItem
      tempList = me.getTempList(item)
      !me.clickItem ? sameItem = true : sameItem = me.$compareObj(me.getTempList(me.clickItem), tempList)
      if (type === 'click') {
        me.clickItem = item
        if (sameItem) {
          me.clickStatus = !me.clickStatus
          if (!me.clickStatus) {
            me.clickItem = null
          }
        } else {
          me.clickStatus = true
        }
      } else if (type === 'enter') {
        if (me.clickStatus && !sameItem) {
          await me.setClickItem('clear')
        }
      }
      if (tempList && tempList.length > 0) {
        tempList.forEach(async element => {
          portNumber = parseInt(element)
          if (portNumber <= me.portNumber) {
            imgItem = (me.onlySFPlist.indexOf(portNumber) < 0) ? document.getElementById('ethernet_' + portNumber) : null
            circelImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'circle')[0] : null
            textImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'st0')[0] : null
            sfpItem = (me.portList[portNumber - 1].val.Combo || me.onlySFPlist.indexOf(portNumber) > -1) ? document.getElementById('sfp_' + portNumber) : null
            sfpCircleImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'circle')[0] : null
            sfpTextImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'st0')[0] : null

            let setColor = async function () {
              if ((me.portList[portNumber - 1].val.Combo && me.portList[portNumber - 1].val.MediaType === 'fiber') || me.onlySFPlist.indexOf(portNumber) > -1) {
                sfpCircleImg.style.fill = '#FFFF00'
                sfpTextImg.style.fill = '#2F2F2F'
              } else {
                circelImg.style.fill = '#FFFF00'
                textImg.style.fill = '#2F2F2F'
              }
            }
            let clearColor = async function () {
              if (sfpItem) {
                sfpCircleImg.style.fill = '#3B415F'
                sfpTextImg.style.fill = '#FFFFFF'
              }
              if (imgItem) {
                circelImg.style.fill = '#3B415F'
                textImg.style.fill = '#FFFFFF'
              }
            }
            if (type === 'click') {
              me.clickStatus ? setColor() : clearColor()
            } else if (type === 'enter') {
              setColor()
            } else if (type === 'leave') {
              await clearColor()
              if (me.clickStatus) {
                me.setClickItem('set')
              }
            }
          }
        })
      } else {
        if (me.clickStatus && type === 'leave') {
          await me.setClickItem('set')
        }
      }
    },
    setClickItem: async function (type) {
      let tempList = this.getTempList(this.clickItem)
      let me = this
      let portNumber, imgItem, circelImg, textImg, sfpItem, sfpCircleImg, sfpTextImg
      if (type === 'set') {
        if (tempList && tempList.length > 0) {
          tempList.forEach(element => {
            portNumber = parseInt(element)
            if (portNumber <= me.portNumber) {
              imgItem = (me.onlySFPlist.indexOf(portNumber) < 0) ? document.getElementById('ethernet_' + portNumber) : null
              circelImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'circle')[0] : null
              textImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'st0')[0] : null
              sfpItem = (me.portList[portNumber - 1].val.Combo || me.onlySFPlist.indexOf(portNumber) > -1) ? document.getElementById('sfp_' + portNumber) : null
              sfpCircleImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'circle')[0] : null
              sfpTextImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'st0')[0] : null
              if ((me.portList[portNumber - 1].val.Combo && me.portList[portNumber - 1].val.MediaType === 'fiber') || me.onlySFPlist.indexOf(portNumber) > -1) {
                sfpCircleImg.style.fill = '#FFFF00'
                sfpTextImg.style.fill = '#2F2F2F'
              } else {
                circelImg.style.fill = '#FFFF00'
                textImg.style.fill = '#2F2F2F'
              }
            }
          })
        }
      } else if (type === 'clear') {
        if (tempList && tempList.length > 0) {
          tempList.forEach(element => {
            portNumber = parseInt(element)
            if (portNumber <= me.portNumber) {
              imgItem = (me.onlySFPlist.indexOf(portNumber) < 0) ? document.getElementById('ethernet_' + portNumber) : null
              circelImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'circle')[0] : null
              textImg = (imgItem) ? me.$getElementsByClassName(imgItem, 'st0')[0] : null
              sfpItem = (me.portList[portNumber - 1].val.Combo || me.onlySFPlist.indexOf(portNumber) > -1) ? document.getElementById('sfp_' + portNumber) : null
              sfpCircleImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'circle')[0] : null
              sfpTextImg = (sfpItem) ? me.$getElementsByClassName(sfpItem, 'st0')[0] : null
              if (sfpItem) {
                sfpCircleImg.style.fill = '#3B415F'
                sfpTextImg.style.fill = '#FFFFFF'
              }
              if (imgItem) {
                circelImg.style.fill = '#3B415F'
                textImg.style.fill = '#FFFFFF'
              }
            }
          })
        }
      }
    },
    getClickStatus: function (data) {
      return this.$compareObj(this.clickItem, data)
    },
    onDeviceClick: function () {
      this.$store.commit('updatedeviceCollapsed', !this.deviceCollapsed)
    },
    onClose: function () {
      this.$store.commit('updateGetDeviceData', false)
      if (this.portStatusIntervalList.length > 0) {
        this.portStatusIntervalList.forEach(elements => {
          clearInterval(elements)
        })
        this.portStatusIntervalList = []
      }
      clearInterval(this.selectInterval)
      this.portStatusInterval = null
      this.selectInterval = null
      this.$forceUpdate()
    },
    setTransform (type, id, speed) {
      let tips = (type === 'sfp') ? 'tooltip_sfp_' : 'tooltip_'
      if (document.getElementById(tips + id).firstElementChild.getBoundingClientRect().width < 40) {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 15
        let y = parseFloat(d[1]) + 7
        switch (speed) {
          case '10M':
          case '10G':
          case '2.5G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      } else {
        let d = document.getElementById(tips + id).firstElementChild.getAttribute('d')
        d = d.split(/(?=[MH])/)
        d = d[0].substring(1)
        d = d.split(' ')
        let txt = document.getElementById(tips + id).lastElementChild
        let x = parseFloat(d[0]) - 19
        let y = parseFloat(d[1]) + 9
        switch (speed) {
          case '10M':
          case '10G':
            break
          case '100M':
            x = x - 2
            break
          case '1G':
          case '5G':
            x = x + 2
            break
          case '2.5G':
            x = x - 1
            break
        }
        txt.removeAttribute('transform')
        txt.setAttribute('x', x)
        txt.setAttribute('y', y)
      }
    },
    ...mapMutations({
    })
  },
  computed: {
    ...mapState({
      currentUser: state => state.module.currentUser,
      fwinfo: state => state.module.fwinfo,
      systemHostInfo: state => state.module.systemHostInfo,
      portNumber: state => state.module.portNum,
      deviceCollapsed: state => state.app.deviceCollapsed,
      showFullLoading: state => state.module.showFullLoading,
      getDeviceData: state => state.app.getDeviceData,
      lagGroupMap: state => state.module.lagGroupMap,
      portMap: state => state.module.portMap,
      reloadDeviceInfo: state => state.module.reloadDeviceInfo,
      selectMenu: state => state.app.selectMenu,
      intervalTime: state => state.app.intervalTime,
      portStatus: state => state.module.portStatus
    }),
    rightTitle () {
      let result = ''
      switch (this.selectType) {
        case 'port':
          result = this.$t('deviceinfo.porttitle')
          break
        case 'vlan':
          result = this.$t('deviceinfo.vlantitle')
          break
        case 'lacp':
          result = this.$t('deviceinfo.LAGtitle')
          break
      }
      return result
    },
    onlySFPlist: function () {
      return config.system.sfpPort[this.systemHostInfo.Product]
    }
  }
}
</script>

<style lang="scss" scoped>
.device-info-content {
  height: inherit;
  background: #ffffff;
  border-radius: 4px;
  padding: 10px 20px;
  >.content-header {
    height: 40px;
    color: #000;
    display: flex;
    justify-content: flex-start;
    .icon {
      cursor: pointer;
    }
    .title {
      margin-left: 15px;
      font-family: 'Roboto-B';
      font-size: 16px;
    }
  }
  >.content-body {
    height: calc(100% - 40px);
    display: flex;
    justify-content: space-between;
    .device-left {
      flex: 2;
      color: #000000;
      position: relative;
      flex-direction: column;
      .formRow {
        display: flex;
        justify-content: flex-start;
        flex-wrap: nowrap;
        .title {
          padding-right: 5px;
        }
        &.legend {
          position: absolute;
          bottom: 0px;
          right: 0px;
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap-reverse;
          align-items: center;
          >.link, >.nolink, >.tenG-link, >.mirror_source, >.mirror_des {
            &::before {
              content: "";
              display: inline-block;
              width: 14px;
              height: 14px;
              margin: 0px 5px 1px 5px;
              margin-bottom: 1px;
              width: 7px;
              height: 7px;
              border-radius: 50%;
            }
          }
          >.link::before {
            background-color: #7ED321;
          }
          >.nolink::before {
            background-color: #DBDDDD;
          }
          >.tenG-link::before {
            background-color: #32CCFF;
          }
          >.mirror_source::before {
            background-color: #4AD2E2;
          }
          >.mirror_des::before {
            background-color: #E38DF5;
          }
          .icon-tick, .icon-btn_close, .link, .nolink {
          display: inline-block;
          }
        }
      }

      .q-select {
        width: auto;
        /deep/ .dropdown-menu {
          left: -1px;
          min-width: 200px;
          height: auto;
          overflow: auto;
        }
        &::after {
          background-color: #000;
          top: -25px;
        }
      }
      svg {
        margin-top: 20px;
        height: 70px;
      }
      &.Link {
        svg {
          background: #7ED321;
          padding: 2px;
        }
      }
    }
    .device-right {
      color: #000;
      flex: 2;
      padding-left: 20px;
      .scrollbar-body{
        height: calc(100% - 5px);
      }
      .detail {
        display: flex;
        padding-right: 8px;
        > ul {
          height: 100%;
          width: 50%;
          margin-bottom: 0px;
          padding: 0px;
          flex: 1;
          li {
            height: 30px;
            line-height: 30px;
            list-style-position: inside;
            padding: 0px 10px;
            >.title{
              display: inline-block;
              margin-right: 10px;
            }
            &:hover, &.onclick {
              background-color: #7FD5FF;
              border-radius: 15px;
              cursor: default;
            }
          }
        }
        .port {
          // display: flex;
          .port-cell {
            display: inline-block;
            width: 22px;
            height: 22px;
            line-height: 22px;
            border-radius: 12px;
            background-color: #fff;
            color: #000000;
            margin-left: 10px;
            text-align: center;
            &.all {
              width: auto;
              padding: 0 5px;
            }
            &.selected {
              background-color: #7FD5FF;
            }
            &:hover {
              cursor: pointer;
              background-color: #B3E6FF;
            }
            &.disabled {
              background-color: rgba(0,0,0,0.20);
              color: rgba(246,243,243,0.60);
              cursor: default;
              pointer-events: none;
            }
          }
        }
        &.rate {
          >.col-body {
            width: 100%;
          }
          // display: initial;
        }
      }
    }
    .line {
      width: 1px;
      height: 100%;
      border-right: solid 1px #000000;
      margin: auto 5px;
    }
  }
}
.link_icon {
  background: #4AD2E2;
  width: 10px;
  height: 10px;
}
.lldp {
  .link_icon {
    background: #E38DF5;
  }
}
.legent-item {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/DeviceInfo.vue